import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux-immutable';
import { History } from 'history';

import languageReducer from 'store/LanguageProvider/reducer';
import UserReducer from 'store/user/reducer';
import ContractReducer from 'store/contract/reducer';
import CredentialsReducer from 'store/credentials/reducer';
import globalReducer from 'store/global/reducer';
import sinistreReducer from 'store/sinistre/reducer';
import geolocAgentReducer from 'store/geolocAgent/reducer';
//inject app reducers
const appReducers = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    intl: languageReducer,
    user: UserReducer,
    contract: ContractReducer,
    question: CredentialsReducer,
    global: globalReducer,
    sinistre: sinistreReducer,
    agent: geolocAgentReducer,
  });

export default appReducers;
